<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    机场东站<br>
站点介绍<br>
机场东站位于宝安区航站四路和宝安大道中间的绿化区内，延宝安大道基本呈东西走向布置。该站为高架站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:21	23:00	1号线	2分钟	4分40秒<br>
机场东	--	--	1号线	2分钟	4分40秒<br>
左炮台东	06:10	23:50	12号线	4分钟	8分钟<br>
海上田园东	06:42	23:22	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:20	23:00	1号线	3分45秒	5分45秒<br>
机场东	--	--	1号线	3分45秒	5分45秒<br>
左炮台东	06:11	23:50	12号线	8分钟	8分钟<br>
海上田园东	06:42	23:22	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:20	00:00	1号线	3分45秒	5分45秒<br>
机场东	--	--	1号线	3分45秒	5分45秒<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>
<br>
站点出口信息<br>
A出入口:<br>
机场六道、航站五路<br><br>
B出入口:<br>
宝安大道、公共汽车接驳站场<br><br>
C出入口:<br>
站外施工已关闭<br><br>
D出入口:<br>
站外施工已关闭<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 福围<br>
338、615、B767、M387、M419、M433、M530、B929<br><br>
B出入口:<br>
公交站名： 机场东地铁站西<br>
727、B875、B929、M387<br><br>
B出入口:<br>
公交站名： 机场东公交接驳站<br>
M237、M291、M331、M332、M334、M351<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shierhaoxian",
          title: "12号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>